export const requiredEntreeContentsByType: { [index: string]: string[] | null } = {
    Burrito: null,
    Bowl: null,
    Quesadilla: null,
    Salad: null,
    Tacos: null,
    KidsBYO: null,
    KidsQuesadilla: ['CMG-5401']
  };

  export enum TemporaryContentGroups {
    SideContentGroup = 'SideGroup',
    DrinkContentGroup = 'DrinkGroup'
  }